module.exports = __webpack_public_path__ + "img/logoGrandE.f74cf9e0.svg";